export default __webpack_public_path__ + "static/media/pursuit-menu-calendar-on.0c453e3d.svg";